export class LoadSearchResult {
  static readonly type = '[Global Search Result] Load Search Results';
  constructor(public searchTerm: string) {}
}
